import { inject } from "@angular/core";
import { CanMatchFn } from "@angular/router";
import { getEffectiveAptUrl } from "src/app/guards/getEffectiveAptUrl";
import { StandardLogService } from "src/standard/logging/logging";
import { waitForPublicSettings } from "src/standard/services/waitForPublicSettings";
import invariant from "tiny-invariant";

export const TryPrependAFDRouteMatchGuard = (async (route, segments) => {
  const logger = inject(StandardLogService);

  await waitForPublicSettings();

  invariant(globalThis.__settings);
  const azureFrontDoor = globalThis.__settings.azureFrontDoor;
  if (!azureFrontDoor?.enabled || !azureFrontDoor.defaultAFDRoute) {
    return false;
  }

  const [path] = getEffectiveAptUrl(
    "/" + segments.map((x) => x.path).join("/"),
  );

  const [_, ...pathParts] = path.split("/");
  logger.logTrace("AFD::FE TryPrependAFDRouteMatchGuard with path", {
    path,
    afdRoute: azureFrontDoor.defaultAFDRoute,
    pathParts,
  });

  if (pathParts.length > 0) {
    const firstPart = pathParts[0]!.toLowerCase();
    const afdRoutes = azureFrontDoor.afdRoutes ?? [
      azureFrontDoor.defaultAFDRoute,
    ];

    logger.logTrace(
      "AFD::FE TryPrependAFDRouteMatchGuard checking first part",
      {
        firstPart,
        afdRoutes,
      },
    );

    if (afdRoutes.includes(firstPart)) {
      logger.logTrace(
        "AFD::FE TryPrependAFDRouteMatchGuard found matching AFD route, not prepending, returning early",
      );

      return false;
    }

    // If the first part is not the afd route, we can prepend the defaultAFDRoute
    const newPathParts: string[] = [azureFrontDoor.defaultAFDRoute];
    for (const part of pathParts) {
      newPathParts.push(part);
    }

    const newPath = `/${newPathParts.join("/")}`;

    logger.logTrace("AFD::FE TryPrependAFDRouteMatchGuard redirecting to", {
      currentUrl: window.location.pathname,
      newPath,
    });

    window.location.pathname = newPath;

    // match, do not continue
    return true;
  }

  logger.logTrace(
    "AFD::FE TryPrependAFDRouteMatchGuard no path parts, not prepending, returning false",
  );

  // No redirect
  return false;
}) satisfies CanMatchFn;
